import { render, staticRenderFns } from "./BatchCreate.vue?vue&type=template&id=5c254d8c&scoped=true"
import script from "./BatchCreate.vue?vue&type=script&lang=js"
export * from "./BatchCreate.vue?vue&type=script&lang=js"
import style0 from "./BatchCreate.vue?vue&type=style&index=0&id=5c254d8c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c254d8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/TypXw3yGP/0/DHCCorporation/dhc-cloud-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c254d8c')) {
      api.createRecord('5c254d8c', component.options)
    } else {
      api.reload('5c254d8c', component.options)
    }
    module.hot.accept("./BatchCreate.vue?vue&type=template&id=5c254d8c&scoped=true", function () {
      api.rerender('5c254d8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/BatchCreate.vue"
export default component.exports